import "bootstrap/dist/css/bootstrap.min.css";

import 'font-awesome/css/font-awesome.css'

import "./fonts/cabin-bold/fonts.css";
import "./fonts/lato/fonts.css";

import "./index.css";
import "./styles/main.css";

import React from "react";
import ReactDOM from "react-dom";
import {Provider} from "react-redux";

import {store} from "./store";
import registerServiceWorker from "./registerServiceWorker";
import App from "./components/app/app";

import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';

import { WhiteLabelProvider } from 'react-whitelabel';
import { labels, whiteLabelBrand } from './whitelabel/resources';
import { datadogRum } from '@datadog/browser-rum';
import { VERSION } from './version';

ReactDOM.render(
    <WhiteLabelProvider labels={labels} selectedLabel={whiteLabelBrand}>
        <Provider store={store}>
            <App/>
        </Provider>
    </WhiteLabelProvider>,
    document.getElementById("root")
);
registerServiceWorker();

datadogRum.init({
    applicationId: process.env.REACT_APP_DATADOG_APP_ID, 
    clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: process.env.REACT_APP_DATADOG_APP_NAME,
    env: process.env.REACT_APP_ENVIRONMENT,
    // Specify a version number to identify the deployed version of your application in Datadog 
    version: VERSION,
    sampleRate: 100,
    trackInteractions: true
});



// WEBPACK FOOTER //
// ./src/index.js